import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Footer = () => {
  return (
    <>
      {/* Structured data for organization (SEO boost) */}
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Nordic Route",
              "url": "https://www.nordicroute.se",
              "logo": "https://www.nordicroute.se/logo.png",
              "description": "Nordisk partner för logistik och transporter – med fokus på precision, trygghet och långsiktiga relationer.",
              "contactPoint": [{
                "@type": "ContactPoint",
                "telephone": "+46-8-123-45-67",
                "contactType": "customer service",
                "availableLanguage": ["Swedish", "English"]
              }]
            }
          `}
        </script>
      </Helmet>

      <footer
        role="contentinfo"
        className="border-t border-slate-200 bg-black px-6 py-12 text-slate-300 lg:px-8"
      >
        <div className="mx-auto max-w-6xl">

          {/* Logo + namn */}
          <div className="flex flex-col items-center gap-3 pb-8 text-center sm:items-start sm:text-left">
            <div className="flex items-center gap-2">
              <span
                aria-hidden="true"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-slate-800 text-xs font-semibold tracking-widest text-slate-100"
              >
                NR
              </span>
              <span className="text-sm font-semibold tracking-wide text-slate-100">
                Nordic Route
              </span>
            </div>

            <p className="max-w-md text-sm leading-relaxed text-slate-400">
              Nordisk partner för logistik och transporter – med fokus på precision, trygghet och
              långsiktiga relationer.
            </p>
          </div>

          {/* 3 kolumner */}
          <div className="grid gap-10 text-sm sm:grid-cols-2 lg:grid-cols-3">

            {/* Om företaget */}
            <div className="space-y-3">
              <h3 className="text-sm font-semibold text-slate-100">Nordic Route</h3>
              <p className="text-sm leading-relaxed text-slate-400">
                Vi hjälper företag i hela Norden med effektiva transporter, smart ruttplanering och
                transparent uppföljning.
              </p>
            </div>

            {/* Snabblänkar */}
            <nav aria-label="Snabblänkar" className="space-y-3">
              <h3 className="text-sm font-semibold text-slate-100">Snabblänkar</h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/services"
                    className="text-sm text-slate-400 transition hover:text-slate-200"
                  >
                    Tjänster
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-slate-400 transition hover:text-slate-200"
                  >
                    Om oss
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-sm text-slate-400 transition hover:text-slate-200"
                  >
                    Kontakt
                  </Link>
                </li>
                <li>
                <Link 
                  to="/privacy-policy" 
                  className="text-sm text-slate-400 transition hover:text-slate-200"
                >
                  Integritetspolicy
                </Link>
              </li>                                      
              </ul>
            </nav>

            {/* Kontakt */}
            <div className="space-y-3">
              <h3 className="text-sm font-semibold text-slate-100">Kontakt</h3>
              <div className="space-y-2 text-sm text-slate-400">
                <p>
                  E-post:{' '}
                  <a
                    href="mailto:nordicroutestransport@gmail.com"
                    aria-label="Skicka e-post till Nordic Route"
                    className="underline-offset-4 hover:text-slate-200 hover:underline"
                  >
                    nordicroutestransport@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-10 border-t border-slate-800 pt-6 text-xs text-slate-500">
            <p>© {new Date().getFullYear()} Nordic Route. Alla rättigheter förbehållna.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
